import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

// Components
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'

// Lib MISC
import '@/styles/main.scss'
import styles from './style.scss'

const cx = classnames.bind(styles)

export const propTypes = {
  children: PropTypes.array,
  lang: PropTypes.string,
}
function Layout ({ children, lang }) {

  // set props lang in all children
  const childrenWithLang = React.Children.map(children, child =>
    React.isValidElement(child)
      ? React.cloneElement(child, { lang })
      : child
  );

  return (
    <div className={cx('layout')}>
      <Header lang={lang} />
      <div className={cx('home')}>
        {childrenWithLang}
      </div>
      <Footer lang={lang} />
    </div>
  )
}

Layout.propTypes = propTypes

export default Layout
